"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* tslint:disable:max-classes-per-file */
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            Framework_ElapsedTimeLessThanMinute: "Less than a minute",
            Framework_ElapsedTimeMinute: "One minute",
            Framework_ElapsedTimeMinutes: "{0} minutes",
            Framework_ElapsedTimeMoreThanHour: "More than a hour",
            Framework_LocalStorageError: "Local Storage space error",
            Framework_LocalStorageQuotaError: "Local Storage space quota exceeded error",
            Framework_UnexpectedError: "An unexpected client error has occurred",
        },
    });
    // tslint:disable-next-line:variable-name
    $dyn._microTasks = [];
    var performingMicroTasks = false;
    /** Observable flag that tracking whether the client is processing interactions. */
    $dyn.clientBusy = $dyn.observable(false);
    /**
     * @deprecated
     */
    $dyn.extendedStyles = {};
    function isDisposable(obj) {
        return obj && obj.dispose;
    }
    $dyn.isDisposable = isDisposable;
    /**
     * Represents the boot loader for the client.
     * @description Supports a pipeline made of promises where each step supports asynchronous and custom sequential or parallel operations.
     * Asynchronous steps should be minimized boot time and by default there should no asynchronous steps.
     */
    var boot;
    (function (boot) {
        function start() {
            $dyn.log.boot && $dyn.log.boot("Boot: start");
            $dyn.time("Init");
            // Create the boot "pipeline"
            $dyn.boot.preBoot();
            // Allows for dynamics resources to be added to the boot process
            $dyn.resources.getRequired().always(function () {
                $dyn.boot.preStart();
                $dyn.boot.loadShell();
                $dyn.boot.initShell();
                $dyn.boot.init();
                $dyn.timeEnd("Init");
                $dyn.boot.loadInitalForm();
                $dyn.log.boot && $dyn.log.boot("Boot: unlocking layout");
                $dyn.ui.layout(false);
                $dyn.boot.postNavigate();
                $dyn.boot.startMonitoring();
                if (typeof (msWriteProfilerMark) !== "undefined") {
                    msWriteProfilerMark("initShell,StopTM");
                }
                $dyn.log.boot && $dyn.log.boot("Boot: started");
            });
        }
        boot.start = start;
        function preBoot() {
            if (!$dyn.layout.supportsFlexOrGrid() || !$dyn.util.historySupported() || !$dyn.util.mutationObserverSupported() || $dyn.util.isIE10()) {
                window.location.href = "/Error/BrowserNotSupported.htm";
            }
        }
        boot.preBoot = preBoot;
        boot.preStart = function () { };
        function loadShell() {
            var dataBindShellTask = (new $dyn.PerformanceTask("dataBindShell")).start();
            // set flag for initializing the shell
            if (!$dyn.shell.isShellInitializing()) {
                $dyn.async.pending.increment("Starting to initialize isShellInitializing true");
                $dyn.shell.isShellInitializing(true);
            }
            if ($dyn.restrictedNavigation) {
                // Replace default NavBar, Company, and User with Popout version stubs.
                // note for embedded we still want the popout bar but we will just hide it , we need company and user in client logic.
                $dyn.shell.NavBarDocumentId = "PopoutNavBar";
                $dyn.shell.CompanyDocumentId = "PopoutCompany";
                $dyn.shell.UserDocumentId = "PopoutUser";
                // Override shell function which should not exist on a popout or limitedNav window.
                // tslint:disable-next-line:no-empty
                $dyn.shell.restartNavigationStack = function () { };
                // blank out goHome for popouts, otherwise make it a page refresh for other
                // cases of $dyn.restrictedNavigation
                if ($dyn.popout) {
                    // tslint:disable-next-line:no-empty
                    $dyn.shell.goHome = function () { };
                }
                else {
                    $dyn.shell.goHome = function () {
                        window.location.reload();
                    };
                }
            }
            if ($dyn.isEmbedded) {
                $(document.body).addClass("isEmbedded");
                $dyn.dataBind(document.getElementById($dyn.shell.MessageCenterEmbeddedId));
            }
            $dyn.dataBind(document.getElementById($dyn.shell.NavBarDocumentId));
            // this disables the container page on load to eliminate flicker
            $("#mainContainer").css("visibility", "hidden");
            // if no serverForm set default product name
            if (!$dyn.serverForm) {
                $dyn.shell.ProductName($dyn.shell._NoServerProductName);
                $dyn.shell.ProductShortName($dyn.shell._NoServerProductName);
            }
            $dyn.dataBind(document.getElementById("ShellBlockingDiv"));
            $dyn.dataBind(document.getElementById("O365Switcher"));
            dataBindShellTask.stop();
        }
        boot.loadShell = loadShell;
        function initShell() {
            $dyn.shell.init();
        }
        boot.initShell = initShell;
        function startMonitoring() {
            if (!$dyn.value($dyn.shell.hasRestrictedInternet)) {
                $dyn.observe(function () {
                    return $dyn.util.isFlightEnabled("CLIEnableMOITelemetryFeature");
                }, function (featureOn) {
                    if (featureOn) {
                        // When feature gets enabled, load fpv2 script
                        var importUrl = $dyn.shell.rootPath + "Scripts/ext/fpv2." + ($dyn.IsDebugBuild ? "" : "min.") + "js";
                        var newScript = document.createElement("script");
                        newScript.setAttribute("src", importUrl);
                        var footprint_1 = function () {
                            var orgId = $dyn.browserActivity.TraceLogTenant;
                            var sessionId = $dyn.browserActivity.BrowserSessionActivity.Id;
                            window.Footprint.start("d365fo", ["fpc.msedge.net/conf/v2/d365fo/fpconfig.min.json"], 0, JSON.stringify({ oid: orgId, sid: sessionId }), "", {
                                "placeholder.dynamics.com": $dyn.util.fullHost(),
                            }, function (results) {
                                if ($dyn.debug.vs) {
                                    results.forEach(function (value) {
                                        console.log(value.Conn + " " + measurementNames_1[value.T] + ": " + value.Result.toString());
                                    });
                                }
                            });
                        };
                        var FOOTPRINT_INTERVAL_MILLISECONDS_1 = 10 * 60 * 1000;
                        // Map of measurement type to name
                        var measurementNames_1 = {
                            1: "Latency",
                            8: "Throughput",
                        };
                        var scriptLoadHandler = function () {
                            footprint_1();
                            boot.monitoringInterval = window.setInterval(footprint_1, FOOTPRINT_INTERVAL_MILLISECONDS_1);
                        };
                        newScript.onload = scriptLoadHandler;
                        document.head.appendChild(newScript);
                        return false;
                    }
                });
            }
        }
        boot.startMonitoring = startMonitoring;
        boot.init = function () { };
        boot.loadInitalForm = function () { };
        boot.postNavigate = function () { };
    })(boot = $dyn.boot || ($dyn.boot = {}));
    function _performMicroTasks() {
        performingMicroTasks = true;
        $dyn.log.framework && $dyn.log.framework("Framework: performing micro tasks");
        // Take a copy
        var tasks = $dyn._microTasks.slice(0);
        $dyn._microTasks.length = 0; // Clear the list of microTasks after taking a copy of the array
        for (var i = 0, len = tasks.length; i < len; i++) {
            var task = tasks[i];
            task.func.call(task.thisArg);
        }
        performingMicroTasks = false;
    }
    $dyn._performMicroTasks = _performMicroTasks;
    // Private variable
    var microTaskElement;
    var microTaskCount = 0;
    var microTaskObserver;
    if ($dyn.util.mutationObserverSupported()) {
        microTaskObserver = new MutationObserver($dyn._performMicroTasks);
    }
    else {
        var errorMessage = "The browser you are currently using does not support one or more features required to run this application.  " +
            "Please upgrade to the latest version of your browser and try again.";
        $dyn.logError(errorMessage);
    }
    function microTask(func, thisArg) {
        if (performingMicroTasks) {
            func.call(thisArg);
            return;
        }
        if (microTaskObserver) {
            $dyn._microTasks.push({ func: func, thisArg: thisArg });
            if (!microTaskElement) {
                microTaskElement = document.createElement("span");
                microTaskObserver.observe(microTaskElement, { attributes: true });
            }
            microTaskCount++;
            microTaskElement.setAttribute("count", microTaskCount);
        }
    }
    $dyn.microTask = microTask;
    /**
     * Utility to get a qualified URL given an application relative path
     */
    function url(urlString) {
        var resourcePath = $dyn.util.parseUrl(urlString);
        if (resourcePath.path.indexOf("/") !== 0) {
            return $dyn.shell.rootPath + $dyn.applicationRoot + resourcePath.path;
        }
        else {
            return resourcePath.url;
        }
    }
    $dyn.url = url;
    /**
     * The relative path to the application root in the current host.
     * @description This is used by framework during host setup
     */
    $dyn.applicationRoot = "Resources/Html/";
    /**
     * Creates a prototype using prototypical inheritance.
     * @description Does classical JavaScript prototype chaining (prototypical inheritance). The childPrototype's prototype will be the base prototype.
     * @param basePrototype The base prototype object whose properties will be extended by the child.
     * @param childPrototype The child prototype.
     */
    function extendPrototype(basePrototype, childPrototype) {
        return Object.create(basePrototype, $dyn.getOwnPropertyDescriptors(childPrototype));
    }
    $dyn.extendPrototype = extendPrototype;
    /**
     * Gets the property descriptors for an object.
     * @description Can be combined with Object.create or Object.defineProperties.
     */
    function getOwnPropertyDescriptors(object) {
        var e_1, _a;
        // It has been proposed that Object.getOwnPropertyDescriptors be added in ES-Harmony, but it is a little early to do a polyfill for it.
        var properties = Object.getOwnPropertyNames(object);
        var propertiesObject = {};
        try {
            for (var properties_1 = __values(properties), properties_1_1 = properties_1.next(); !properties_1_1.done; properties_1_1 = properties_1.next()) {
                var propertyName = properties_1_1.value;
                propertiesObject[propertyName] = Object.getOwnPropertyDescriptor(object, propertyName);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (properties_1_1 && !properties_1_1.done && (_a = properties_1.return)) _a.call(properties_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return propertiesObject;
    }
    $dyn.getOwnPropertyDescriptors = getOwnPropertyDescriptors;
    if (!window.msWriteProfilerMark) {
        // msWriteProfilerMark is a MS api to log ETW events.
        // Use the timeStamp (shows in Chrome time line) function if logging is enabled and the function is available.
        // tslint:disable-next-line:no-console
        // tslint:disable-next-line:no-empty
        window.msWriteProfilerMark = ($dyn.debug.performance && window.console && console.timeStamp && Function.prototype.bind.call(console.timeStamp, console)) || (function () { });
    }
    /**
     * Represents a (non-overlapping) performance task that can be started and stopped.
     * @description On the Windows platform, an ETW event will be logged.
     * For best performance of recording performance task, create a singleton instance per task name such as if a object prototype.
     * For task that can be enable or disable it is recommended to check if the task is set before calling start/stop to avoid the cost of a function call.
     */
    var PerformanceTask = /** @class */ (function () {
        function PerformanceTask(taskName, canLog) {
            this.taskName = taskName;
            this.startTaskName = taskName + $dyn.PerformanceTask.startSuffix;
            this.endTaskName = taskName + $dyn.PerformanceTask.stopSuffix;
            this.enableDetails = true;
            this.log = canLog ? $dyn.log.performance : null;
        }
        PerformanceTask.prototype.start = function (details) {
            var taskName;
            if (this.enableDetails && details !== undefined) {
                // Enable details is off by default as it slightly degrades performance.
                taskName = this.taskName + " " + details + $dyn.PerformanceTask.startSuffix;
            }
            else {
                taskName = this.startTaskName;
            }
            msWriteProfilerMark(taskName);
            this.log && this.log("performance: " + taskName);
            return this;
        };
        PerformanceTask.prototype.stop = function (details) {
            var taskName;
            if (this.enableDetails && details !== undefined) {
                taskName = this.taskName + " " + details + $dyn.PerformanceTask.stopSuffix;
            }
            else {
                taskName = this.endTaskName;
            }
            msWriteProfilerMark(taskName);
            this.log && this.log("performance: " + taskName);
            return this;
        };
        PerformanceTask.startSuffix = ",StartTM";
        PerformanceTask.stopSuffix = ",StopTM";
        return PerformanceTask;
    }());
    $dyn.PerformanceTask = PerformanceTask;
    /**
     * Represents a (non-overlapping) performance task associated to a dom element that can be started and stopped.
     * @description On the Windows platform, an ETW event will be logged.
     * For best performance of recording performance task, create a singleton instance per task name.
     */
    var DomPerformanceTask = /** @class */ (function () {
        function DomPerformanceTask(taskName, canLog) {
            if (canLog === void 0) { canLog = false; }
            this.taskName = taskName;
            this.startTaskName = taskName + $dyn.PerformanceTask.startSuffix;
            this.endTaskName = taskName + $dyn.PerformanceTask.stopSuffix;
            this.verbose = $dyn.debug.domPerformance;
            this.log = canLog ? $dyn.log.performance : null;
            this.enableDetails = true;
        }
        DomPerformanceTask.prototype.start = function (targetElement, details) {
            if (this.enableDetails) {
                this._writeDetails($dyn.PerformanceTask.startSuffix, targetElement, details);
            }
            else {
                msWriteProfilerMark(this.startTaskName);
                this.log && this.log("performance: " + this.startTaskName);
            }
            if (this.verbose) {
                var perf = targetElement.dynPerformance;
                if (!perf) {
                    perf = targetElement.dynPerformance = [];
                }
                details = details !== undefined ? " " + details : "";
                perf.push($dyn.performanceMark(this.startTaskName + details));
            }
            return this;
        };
        DomPerformanceTask.prototype.stop = function (targetElement, details) {
            // The details of the start event should match the stop event.
            if (this.enableDetails) {
                this._writeDetails($dyn.PerformanceTask.stopSuffix, targetElement, details);
            }
            else {
                msWriteProfilerMark(this.endTaskName);
                this.log && this.log("performance: " + this.endTaskName);
            }
            if (this.verbose) {
                var perf = targetElement.dynPerformance;
                if (!perf) {
                    perf = targetElement.dynPerformance = [];
                }
                if (perf.push) {
                    details = details !== undefined ? " " + details : "";
                    perf.push($dyn.performanceMark(this.endTaskName + details));
                }
            }
        };
        DomPerformanceTask.prototype._writeDetails = function (suffix, targetElement, details) {
            details = details !== undefined ? details : "";
            var control = $(targetElement).addBack().closest("[data-dyn-controlname]");
            var roleName = control.attr("data-dyn-role") || "";
            msWriteProfilerMark(this.taskName + ".ByType " + roleName + suffix);
            var controlName = control.attr("data-dyn-controlname") || "";
            if (controlName) {
                msWriteProfilerMark(this.taskName + ".ByName " + controlName + "-" + roleName + suffix);
            }
            details = details ? " " + details : "";
            var taskName = this.taskName + details + suffix;
            msWriteProfilerMark(taskName);
            this.log && this.log("performance: " + taskName);
        };
        return DomPerformanceTask;
    }());
    $dyn.DomPerformanceTask = DomPerformanceTask;
    /**
     * Represents a custom performance mark (that can be associated to any object).
     * @description Needed because PerformanceMark can only be created by performance.mark and is global.
     */
    function performanceMark(name) {
        // TODO: Using function as a workaround to be able to get toString to render correctly in the properties window for better debuging.
        var mark = Object.assign(function () { }, {
            // Note: ideally we would use name, but name is already reserved by the function base object.
            markName: name,
            startTime: performance.now(),
        });
        mark.toString = function () {
            return this.markName + ": " + this.startTime;
        };
        return mark;
    }
    $dyn.performanceMark = performanceMark;
    function controlOptions(controlElement) {
        if (!controlElement) {
            throw new Error("Argument null or undefined: controlElement");
        }
        var control = $dyn.ui.getLiveControl(controlElement);
        if (control) {
            return control;
        }
        // The control may not yet exist (dataBinding not performed) so use the server-provided options.
        return controlElement.dynOptions;
    }
    $dyn.controlOptions = controlOptions;
    /**
     * Constants used within the HTML binding framework
     */
    var Const;
    (function (Const) {
        Const["roleAttribute"] = "data-dyn-role";
        Const["roleInstance"] = "dynRoleInstance";
        Const["stopBindingAttribute"] = "data-dyn-stop-binding";
        Const["templateApplied"] = "data-dyn-template-applied";
        Const["templateAttribute"] = "data-dyn-template";
        Const["templateResolveAction"] = "dynTemplateResolveAction";
    })(Const = $dyn.Const || ($dyn.Const = {}));
    $dyn.const = Const;
    function scrollIntoView(element, scrollContainer) {
        // The scrollTop property is 0 and not settable if the scrollContainer element has no scrollbars or is hidden
        // (eg, a grid in a currently-hidden tab page or group)
        // Chrome will also scroll the parent div when using scrollIntoView
        // http://stackoverflow.com/questions/11039885/scrollintoview-causing-the-whole-page-to-move
        // No Chrome bugs found on this issue.
        // Perf: get .offsetTop was on the same order of magnitude of time as .scrollIntoView
        scrollContainer.scrollTop = element.offsetTop;
    }
    $dyn.scrollIntoView = scrollIntoView;
    /**
     * Fetch the length of an object, unwrapping it if it is observable.
     * @description If the object is an array/observable array, returns the number of elements in the array.
     * @param obj The object to retrieve the length of.
     * @returns the length or undefined if obj was undefined
     */
    function length(obj) {
        var value = $dyn.value(obj);
        if (value) {
            if (value.len) {
                // Value is an observable array (which is a function and function length property is the number of args)
                return value.len;
            }
            else {
                return $dyn.value(value.length);
            }
        }
        return undefined;
    }
    $dyn.length = length;
    /**
     * Returns the unwrapped function.
     * @description Takes a function or an observable wrapping a function and returns the function.
     * Includes safeguards to return an empty function if the supplied parameter is either null or not a function.
     */
    function getFunction(func) {
        var value = $dyn.value(func);
        if (typeof (value) === "function") {
            return value;
        }
        return $dyn.util.emptyfunction;
    }
    $dyn.getFunction = getFunction;
    $dyn.function = getFunction;
    /**
     * Execute a function using a given context.
     * @description Calls the specified function with the thisArg as the this context and uses any
     * additional parameters as parameters that should be passed to the function.
     * Includes safeguards to noop if the supplied function parameter is either null or not a function.
     * @example // To call a function and pass three arguments to the called function you could do something like:
     * $dyn.callFunction(self.someFunction, self, true, "ABC", [1, 2, 3, 4]);
     * @param func The function or observable wrapping the function.
     * @param thisArg The object to use as the this context when calling the function.
     */
    function callFunction(func, thisArg) {
        var values = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            values[_i - 2] = arguments[_i];
        }
        // Note: This function was made deprecated so there wasn't confusion between it and $dyn.applyFunction.
        var value = $dyn.value(func);
        if (value && typeof (value) === "function") {
            return value.apply(thisArg, Array.prototype.slice.call(arguments, 2));
        }
        return null;
    }
    $dyn.callFunction = callFunction;
    /**
     * Calls the specified function with the thisArg as the <c>this</c> context and the argsArray as the arguments.
     * @example // To call a function and pass three arguments to the function you would do something like:
     * $dyn.applyFunction(self.someFunction, self, [true, "ABC", [1, 2, 3, 4]]);
     * @param func The function or observable wrapping the function.
     * @param thisArg The object to use as the this context when calling the function.
     * @param argsArray An optional array containing the arguments that should be provided when calling the function.
     */
    function applyFunction(func, thisArg, argsArray) {
        var value = $dyn.value(func);
        if (value && typeof (value) === "function") {
            return value.apply(thisArg, argsArray);
        }
        return null;
    }
    $dyn.applyFunction = applyFunction;
    /**
     * Returns the localized label text for a given label name.
     * @param labelString The label to fetch the text for.
     * @returns The localized label text.
     */
    function label(labelString) {
        var localized = Globalize.localize(labelString);
        return localized !== undefined ? localized : labelString;
    }
    $dyn.label = label;
    function getDefault(value, defaultValue) {
        return value !== undefined ? value : defaultValue;
    }
    $dyn.getDefault = getDefault;
    $dyn.default = getDefault;
    /** Flag that tracks if setting programmatic focus has finished. */
    $dyn.focusCompleted = $dyn.observable(false);
    $dyn.clientInError = $dyn.observable(false);
    var date;
    (function (date_1) {
        // tslint:disable-next-line:no-shadowed-variable
        function format(date, formatString) {
            var value = $dyn.value(date);
            if (value) {
                if (value instanceof Date) {
                    return Globalize.format(value, formatString);
                }
                return Globalize.format(new Date(value), formatString);
            }
            return "";
        }
        date_1.format = format;
    })(date = $dyn.date || ($dyn.date = {}));
    /**
     * Builds a string using the supplied values according to the supplied format.
     * @example
     * // Build a string with the first name, middle initial and last name.
     * var first = "Joanne";
     * var middle = "M";
     * var last = "Gordon";
     * var fullName = $dyn.format("Your name is : {0} {1} {2}", first, middle, last);
     * @param formatString The format in which to build the string. Use bracket notation for placeholders.
     * @param values The values to use in the format.
     * @returns The formatted string.
     */
    function format(formatString) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        if (formatString != null && formatString.replace) {
            return formatString.replace(/{(\d+)}/g, function (match, index) {
                var argIndex = Number(index);
                if (!isNaN(argIndex) && values[argIndex] !== undefined) {
                    var value_1 = $dyn.value(values[argIndex]);
                    // Provide nice formatting for objects. If the object overrides
                    // toString(), use that; otherwise use JSON formatting
                    if (typeof value_1 === "object") {
                        if (value_1 && typeof (value_1.hasOwnProperty) === "function" && value_1.hasOwnProperty("toString")) {
                            return value_1.toString();
                        }
                        else {
                            try {
                                return JSON.stringify(value_1);
                            }
                            catch (error) {
                                // A circular reference error, use just the value
                                return value_1;
                            }
                        }
                    }
                    else {
                        return value_1;
                    }
                }
                else {
                    return "";
                }
            });
        }
        else {
            return formatString;
        }
    }
    $dyn.format = format;
    /**
     * Logs the given error to the console, throws a message box to the user with the passed in message or a default message and sends a client error telemetry event.
     * @description Do *NOT* log any user data (possible PII) within the error message.
     * @param errorMessage  Error that will be logged to the console and uploaded to telemetry
     */
    function logNonFatalError(errorMessage) {
        var options = {};
        if ($dyn.debug.showErrors || ($dyn.version && $dyn.version.buildType === "debug")) {
            options.SecondaryText = errorMessage;
        }
        // Because there is no error object we have no callstack so instead
        // put the error message as the callstack so the telemetry event has some information
        $dyn.telemetry.handleClientError(options, "Framework_UnexpectedError", { callStack: errorMessage });
        $dyn.logError(errorMessage);
    }
    $dyn.logNonFatalError = logNonFatalError;
    /**
     * Assert that a value is truthy and throw an error if not
     */
    $dyn.assert = !$dyn.debug.general ? function () { } : function (value, message) {
        if (!value) {
            throw new Error(message ? message : $dyn.label("Assertion failed"));
        }
    };
    /**
     * Fetches the parent element of the target element from the html template.
     * @description Templates instances (often are also control instance) can have children. During template expansion the children can get placed anywhere
     * in template's dom using the data-dyn-content attribute.  When this happens the parentNode (i.e. physical parent)
     * will not be the template instance dom element (i.e. the logical parent) as in the source before template expansion.
     * However, it is important to note that not all controls need to be the logical children of a parent control.  A control's template can have internal
     * controls such as labels and buttons.  These controls are internal controls, not its logical children so this method will return null for those controls.
     * The templated parent is available when the parent control's template is expanded (which happens at the beginning of the data binding process).
     */
    function templatedParentElement(targetElement) {
        return targetElement.dynTemplatedParent;
    }
    $dyn.templatedParentElement = templatedParentElement;
    function children(targetElement) {
        return $dyn._getChildren(targetElement)();
    }
    $dyn.children = children;
    function _setParent(childElement, newParent) {
        var currentParent = childElement.dynTemplatedParent;
        // If this element is already the child of another element, then remove it from the old child list first
        if (currentParent && currentParent !== newParent) {
            var prevChildrenObservable = $dyn._getChildren(currentParent);
            var prevChildren = $dyn.value(prevChildrenObservable);
            var idx = -1;
            if (prevChildren) {
                idx = prevChildren.indexOf(childElement);
            }
            if (idx >= 0) {
                prevChildren.splice(idx, 1);
                prevChildrenObservable.valueChanged.raise();
            }
        }
        childElement.dynTemplatedParent = newParent;
    }
    $dyn._setParent = _setParent;
    function _getChildren(targetElement) {
        var childrenObservable = targetElement.dynChildren;
        if (!targetElement.dynChildren) {
            // This is a lighter weight version of observable array. It is a currently a private, low-level api.
            // tslint:disable-next-line:no-shadowed-variable
            var children_1 = [];
            targetElement.dynChildren = childrenObservable = $dyn.observable(children_1);
            childrenObservable.__templateChildren = true;
            childrenObservable.set = function (index, childElement) {
                $dyn._setParent(childElement, targetElement);
                children_1[index] = childElement;
            };
            // tslint:disable-next-line:only-arrow-functions
            childrenObservable.splice = function () {
                var len = arguments.length;
                for (var i = 2; i < len; i++) {
                    $dyn._setParent(arguments[i], targetElement);
                }
                return children_1.splice.apply(children_1, arguments);
            };
        }
        return childrenObservable;
    }
    $dyn._getChildren = _getChildren;
    /**
     * Notifies of any changes to the child hierarchy structure for the given target element.
     * @description This computed doesn't actually return a value, but it creates a
     * dependency between itself and all child elements, so that it is notified
     * whenever the child hierarchy changes. This is used so that the computed value changes every time, to avoid
     * caching inside $dyn.computed.
     */
    function childHierarchyChanged(parentElement) {
        return $dyn.computed(function () {
            // tslint:disable-next-line:no-shadowed-variable
            var recurseThroughChildHierarchy = function (children) {
                // Observe the children and recurse.
                if (children) {
                    for (var i = 0, len = children.length; i < len; i++) {
                        var element = children[i];
                        recurseThroughChildHierarchy($dyn.value(element.dynChildren));
                    }
                }
            };
            recurseThroughChildHierarchy($dyn.value(parentElement.dynChildren));
        });
    }
    $dyn.childHierarchyChanged = childHierarchyChanged;
    function isServerBoundDataSource(obj) {
        return obj && obj.__dataSourceName !== undefined;
    }
    $dyn.isServerBoundDataSource = isServerBoundDataSource;
    /** Manages specific modifications to the document header. */
    var htmlDocument;
    (function (htmlDocument) {
        /**
         * This function handles adding a link tag for favicon
         * @param favUrl path to the new fav link
         */
        function setFavicon(favUrl) {
            var link = document.createElement("link");
            link.type = "image/x-icon";
            link.rel = "shortcut icon";
            link.href = favUrl;
            document.getElementsByTagName("head")[0].appendChild(link);
        }
        htmlDocument.setFavicon = setFavicon;
        /**
         * This function handles adding app specific metavalues
         * @param metaTagName metaTagName name to add
         * @param value value to set
         * @param location location of the value
         */
        function setMetaValue(metaTagName, value, location) {
            var link = document.getElementsByName(metaTagName);
            if (link) {
                link[0].setAttribute("content", location + value);
            }
        }
        htmlDocument.setMetaValue = setMetaValue;
        /**
         * This function handles adding app specific metavalues
         * @param name metaTag name to add
         * @param iconObject value to set
         * @param location location of the icon
         */
        function setLinkIconValue(name, iconObject, location) {
            var links = document.getElementsByTagName("link");
            var len = links.length;
            for (var i = 0; i < len; i++) {
                var link = links[i];
                if (link.rel === name) {
                    var sizes = link.getAttribute("sizes");
                    if (sizes === iconObject.small[0]) {
                        link.setAttribute("href", location + iconObject.small[1]);
                    }
                    else if (sizes === iconObject.medium[0]) {
                        link.setAttribute("href", location + iconObject.medium[1]);
                    }
                    else if (sizes === iconObject.large[0]) {
                        link.setAttribute("href", location + iconObject.large[1]);
                    }
                    else if (sizes === iconObject.xlarge[0]) {
                        link.setAttribute("href", location + iconObject.xlarge[1]);
                    }
                }
            }
        }
        htmlDocument.setLinkIconValue = setLinkIconValue;
    })(htmlDocument = $dyn.htmlDocument || ($dyn.htmlDocument = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Dyn.js.map
